import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';
declare const $: any;

/**
 * Директива для инициализации плагина всплывающей подсказки Bootstrap Popover
 * https://getbootstrap.com/docs/3.3/javascript/#popovers
 */

@Directive({
    selector: '[appPopoverMessage]'
})
export class PopoverMessageDirective implements AfterViewInit, OnDestroy {
    @Input() appPopoverMessage: string;
    @Input() triggerBy: 'hover' | 'click' = 'hover';
    @Input() position: 'right' | 'top' | 'bottom' | 'left' = 'right';
    constructor(private _elementRef: ElementRef) {}

    ngAfterViewInit() {
        if (!$() || !$().popover) {
            console.error('Bootstrap popover plugin is unavailable.');
            return;
        }

        const native = this._elementRef.nativeElement;

        /**
         * Свойства тут https://getbootstrap.com/docs/3.4/javascript/#popovers-options
         */
        $(native).popover({
            container: 'body',
            html: true,
            content: this.appPopoverMessage,
            placement: this.position,
            trigger: this.triggerBy,
            animation: false,
        });
    }

    ngOnDestroy() {
        const native = this._elementRef.nativeElement;
        if (!$() || !$().popover) {
            console.error('Bootstrap popover plugin is unavailable.');
            return;
        }

        $(native).popover('destroy');
    }
}
